import { render, staticRenderFns } from "./QuestionSaved.vue?vue&type=template&id=e42c0370&scoped=true&"
import script from "./QuestionSaved.vue?vue&type=script&lang=js&"
export * from "./QuestionSaved.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSaved.vue?vue&type=style&index=0&id=e42c0370&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42c0370",
  null
  
)

export default component.exports